import colors from "shared/styles/colors"
import { ThemeType } from "shared/styles/theme"
import styled from "styled-components"
import theme from "styled-theming"

const smallTextColor = theme("mode", {
    [ThemeType.light]: colors.grey_1,
    [ThemeType.dark]: colors.grey_2
})

export const SmallText = styled.span`
    font-size: 0.938rem;
    font-weight: 400;
    font-family: "Gilroy-Medium", "medium-fallback";
    color: ${smallTextColor};
`

export const SROnly = styled.span`
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0,0,0,0);
    border: 0;
`;